import React from 'react';

export interface IconProps extends React.SVGProps<SVGSVGElement> {
    svgOnly?: boolean;
}

export const Icon: React.FC<IconProps> = ({ children, svgOnly = false, ...rest }) => {
    // SVG illustrations cannot contain the HTML wrapper used by application icons.
    if (svgOnly) {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" {...rest}>
                {children}
            </svg>
        );
    }
    return (
        <i className="app-icon relative inline-flex h-[1.6rem] w-[1.6rem] items-center justify-center transition-none [&_img]:!h-auto [&_svg]:m-0 [&_svg]:inline-flex [&_svg]:h-full [&_svg]:w-full [&_svg]:items-center [&_svg]:fill-transparent [&_svg]:stroke-0 [&_svg]:transition-none">
            <svg xmlns="http://www.w3.org/2000/svg" {...rest}>
                {children}
            </svg>
        </i>
    );
};
